/**
 * Created by manoraj.k on 17/08/17.
 */
import React from "react";
import styled from "styled-components";
import {colors} from "../../colorCodes";

export const GroupButtonsContainer = styled.div`
    display: inline-block;
    border-radius: 4px;
    button {
        border:none;
        border: solid 1px ${colors.brandBlue};
        border-right: none;
        background: ${colors.whiteText};
        color: ${colors.brandBlue};
        font-size:13px;
        height: ${props=>props.height};
        &.selected {
            background: ${colors.selectedBlue};
        }
        cursor: pointer;
    }
    button:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }
    button:last-child {
        border-right: solid 1px ${colors.brandBlue};
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
    button:focus{
        outline:none;
    }
`
